(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/utils/sportsbook-parameters.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/utils/sportsbook-parameters.js');
"use strict";


const validParams = Object.freeze({
  branchId: 'BranchID',
  leagueId: 'LeagueID',
  masterEventId: 'MasterEventID',
  eventId: 'EventID',
  lineId: 'LineID',
  points: 'Points',
  eventType: 'EventType',
  stakeAmount: 'StakeAmount',
  comboStakeAmount: 'ComboStakeAmount'
});
if (svs.isServer) {
  module.exports = validParams;
} else {
  svs.sportsbook.sbtech_api_impl.utils.sportsbookParameters = validParams;
}

 })(window);